module.exports = __webpack_public_path__ + "media/images/promo/laurel-cea33f437a8bdce961d975639c37d6519539381fd9a6ae6733ec5d3dadd26c83.jpeg";